export default __webpack_public_path__ + "static/media/like.d3121f5f.svg";